// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"500":"e5d4429934f0d6e9","506":"f6b8814f24d8e7df"}[chunkId] + ".css";
};